function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "01071417-08B8-4E26-A4ED-B8D9FA3632DA");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Financial-Aid-Packages",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "financialAidPackagesAddDocumentvMultiple",
  transform: "translate(-548.000000, -324.000000)"
}, React.createElement("g", {
  id: "addDocument",
  transform: "translate(424.000000, 131.000000)"
}, React.createElement("g", {
  id: "Fields_&_Inputs/Checkbox_+_Label/Small",
  transform: "translate(124.000000, 191.000000)"
}, React.createElement("g", {
  id: "Icon/Checkbox/Hover",
  transform: "translate(0.000000, 2.000000)"
}, React.createElement("polygon", {
  id: "24pt_Bounding_Box",
  opacity: 0,
  fillRule: "nonzero",
  points: "0 0 24 0 24 24 0 24"
}), React.createElement("path", {
  d: "M17.9999999,21.0000005 L5.99999987,21.0000005 L5.99999987,21.0000005 C4.34314987,21.0000005 2.99999987,19.65685 2.99999987,18.0000005 C2.99999987,18.0000005 2.99999987,18.0000005 2.99999987,18.0000005 L2.99999987,6.00000045 L2.99999987,6.00000045 C2.99999987,4.34315045 4.34314987,3.00000045 5.99999987,3.00000045 L17.9999999,3.00000045 L17.9999999,3.00000045 C19.6568497,3.00000045 20.9999999,4.34315045 20.9999999,6.00000045 L20.9999999,18.0000005 L20.9999999,18.0000005 C20.9999999,19.6568505 19.6568497,21.0000005 17.9999999,21.0000005 L17.9999999,21.0000005 Z M5.99999996,5 L5.99999996,5 C5.44771496,5 4.99999996,5.447715 4.99999996,6 C4.99999996,6 4.99999996,6 4.99999996,6 L4.99999996,18 L4.99999996,18 C4.99999996,18.5522852 5.44771496,19 5.99999996,19 L18,19 L18,19 C18.5522849,19 19,18.5522852 19,18 L19,6 L19,6 C19,5.44771515 18.5522849,5 18,5 L5.99999996,5 Z",
  id: "Fill"
}))))));

var SvgHover = function SvgHover(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHover, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hover.9e908d11.svg";
export { ForwardRef as ReactComponent };